import * as actionTypes from '../actions/flowActionTypes';
import * as authActionTypes from '../actions/authActionTypes';

export type CurrentCustomer = {
    customer: any;
    verified: boolean;
};

type FlowState = {
    currentCustomer: CurrentCustomer;
    currentStep: string;
    customers: any[];
    formData: any;
};

const initialState: FlowState = {
    currentCustomer: {
        customer: {},
        verified: false,
    },
    currentStep: '',
    customers: [],
    formData: {},
};

const flowReducer = (state: FlowState = initialState, action: Action): FlowState => {
    switch (action.type) {
        case authActionTypes.AUTH_AUTHENTICATE_SUCCESS:
        case actionTypes.FLOW_SET_CURRENT_CUSTOMER:
            return {
                ...state,
                currentCustomer: {
                    ...state.currentCustomer,
                    customer: action.payload,
                },
            };
        case authActionTypes.AUTH_AUTHENTICATE_VIA_LOGINLESS_SUCCESS:
            return {
                ...state,
                currentCustomer: {
                    ...state.currentCustomer,
                    customer: action.payload.user,
                },
            };
        case actionTypes.FLOW_SET_CURRENT_CUSTOMER_VERIFIED:
            return {
                ...state,
                currentCustomer: {
                    ...state.currentCustomer,
                    verified: action.payload,
                },
            };
        case actionTypes.FLOW_SET_CURRENT_STEP:
            return {
                ...state,
                currentStep: action.payload,
            };

        case actionTypes.FLOW_SET_FORM_DATA:
            return {
                ...state,
                formData: action.payload,
            };
        case actionTypes.FLOW_CLEAR_FORM_DATA:
            return {
                ...state,
                formData: {},
            };
        case actionTypes.FLOW_ADD_CUSTOMER:
            return {
                ...state,
                customers: [...state.customers, action.payload],
            };
        default:
            return state;
    }
};

export default flowReducer;
